<template>
  <div class="column-info">
    {{ info.title }}
  </div>
</template>

<script>
export default {
  name: 'RankingColumnInfo',

  props: {
    info: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.column-info {
  margin-bottom: 12px;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  color: #1e3a8a;
  font-size: 14px;
}
</style>
